import { useRef } from "react";

/**
 *  Evaluates the provided value with a shallow comparison on the value from the previous render.
 * @param isEqualFn The function used to determine equality between value and previousValue
 *  @returns [isValueChanged: boolean, previousValue: T]
 */
export const useHasValueChanged = <T>(
  value: T,
  isEqualFn = defaultEqualityCheck,
) => {
  const previousContent = useRef<T>(value);

  const previousValue = previousContent.current;
  const isValueChanged = !isEqualFn(value, previousValue);
  previousContent.current = value;

  return [isValueChanged, previousValue] as const;
};

type EqualityFn<T = unknown> = (x: T, y: T) => boolean;

const defaultEqualityCheck: EqualityFn = (a, b) => a === b;
